import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RechtVersionId, StandardrechtMasterDetailEntryMeta, StandardrechtVersionDetailEntryMeta } from '../../../../core/gb-api';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { TranslateNamePipe } from '../../../../shared/pipes/simple/translate-name.pipe';
import { LinkComponent, NavTarget } from '../../../../shared/components/link/link.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { KopfdatenelementComponent } from '../../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { ReadMoreComponent } from '../../../../shared/widgets/read-more/read-more.component';
import { KompaktBelegComponent } from '../../../../shared/kompaktdarstellung/beleg/kompakt-beleg.component';
import { KompaktTimepointComponent } from '../../../../shared/kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { BereinigungsmarkierungComponent } from '../../bereinigungsmarkierung/bereinigungsmarkierung.component';
import { TitleCasePipe } from '@angular/common';
import { BetragPipe } from '../../../../shared/pipes/simple/betrag.pipe';
import { DatumPipe } from '../../../../shared/pipes/simple/datum.pipe';
import { FormatRechteIdPipe } from '../../../../shared/pipes/format/format-rechte-id.pipe';

@Component({
  selector: 'cap-standardrecht-kopfdaten',
  templateUrl: './standardrecht-kopfdaten.component.html',
  styleUrls: ['./standardrecht-kopfdaten.component.scss'],
  imports: [
    KopfdatenelementComponent,
    ReadMoreComponent,
    KompaktBelegComponent,
    LinkComponent,
    KompaktTimepointComponent,
    BereinigungsmarkierungComponent,
    TranslatePipe,
    TitleCasePipe,
    BetragPipe,
    DatumPipe,
    FormatRechteIdPipe
  ]
})
export class StandardrechtKopfdatenComponent implements OnInit, OnDestroy {
  navTargets = NavTarget;

  @Input()
  recht: StandardrechtMasterDetailEntryMeta;
  @Input()
  versionId: RechtVersionId;

  version: StandardrechtVersionDetailEntryMeta;
  stichworte;

  private subscription: Subscription;

  constructor(
    private translate: TranslateNamePipe,
    private translateService: TranslateService
  ) {
    keysToTranslate<string>([
      'Bemerkung',
      'Bereinigungsmarkierung',
      'Entschädigung',
      'EntstandenAus',
      'Entstehungsdatum',
      'FremdeIdentifikation',
      'FremdId',
      'Gesamtwert',
      'NichtOeffentlicheBemerkung',
      'ServitutenregisterNr'
    ]);
  }

  ngOnInit(): void {
    this.version = this.recht.versions.find((v) => v.id.id === this.versionId.id);
    this.setStichwort();
    this.subscription = this.translateService.onLangChange.subscribe(() => {
      this.setStichwort();
    });
  }

  setStichwort() {
    if (this.recht.versions[0].stichwort) {
      this.stichworte = this.translate.transform(this.recht.versions[0].stichwort.text);
    }
    if (this.recht.versions[0].stichwortZusatz) {
      this.stichworte
        ? (this.stichworte += ' ' + this.recht.versions[0].stichwortZusatz)
        : (this.stichworte = this.recht.versions[0].stichwortZusatz);
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
